import PropTypes from "prop-types";
import classNames from "classnames";

import { formatElapsed } from "../services/utilities";
import styles from "./CaptureBar.module.scss";

// The capture row on the Live Tap page, whatever is capturing: state, source,
// level, elapsed, the last words heard, and the source's own controls. The
// host-audio bar (TT-1102, this tab captures) and the Zoom meeting bar
// (TT-1207, Zoom's RTMS stream) each feed it, so a meeting reads the same
// however it is being heard.

// MUI's default icon colour is near-black; the page themes its icon buttons
// through the CSS variables (same as LiveTapPage's transport row).
export const ICON_BTN_SX = {
  color: "var(--color-text-secondary)",
  "&:hover": { color: "var(--color-text-primary)" },
  "&.Mui-disabled": { color: "var(--color-text-muted)" },
};
export const STOP_BTN_SX = {
  color: "var(--color-error)",
  "&.Mui-disabled": { color: "var(--color-text-muted)" },
};

const CaptureBar = ({ label, quiet = false, source, level = null, elapsed = null, lastText, error, children }) => (
  <div className={styles.bar} role="status" aria-live="polite">
    <span className={classNames(styles.rec, { [styles.quiet]: quiet })}>{label}</span>
    <span className={styles.source} title={source}>
      {source}
    </span>
    {level !== null && (
      <div className={styles.meter} aria-hidden>
        <span style={{ width: `${Math.min(100, Math.round(level * 400))}%` }} />
      </div>
    )}
    {elapsed !== null && <span className={styles.elapsed}>{formatElapsed(elapsed)}</span>}
    {lastText && <span className={styles.last}>{lastText}</span>}
    <div className={styles.actions}>{children}</div>
    {error && <span className={styles.error}>{error}</span>}
  </div>
);

CaptureBar.propTypes = {
  /** The state word: Live, Paused, Starting, Ended... */
  label: PropTypes.string.isRequired,
  /** Nothing is being heard right now: the dot stops pulsing. */
  quiet: PropTypes.bool,
  source: PropTypes.string.isRequired,
  /** 0..1 audio level; null hides the meter. */
  level: PropTypes.number,
  /** Seconds; null hides the clock. */
  elapsed: PropTypes.number,
  lastText: PropTypes.string,
  error: PropTypes.string,
  children: PropTypes.node,
};

export default CaptureBar;
